import { useState } from 'react'
import { configurationsService } from '../shared/services/ConfigurationsService'

export interface ISubscribe {
  email: string
  lastname: string
  firstname: string
  company: string
  language: 'fr' | 'en'
}

export const useNewsletter = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const subscribe = async (params: ISubscribe): Promise<boolean> => {
    setIsLoading(true)
    setError(null)
    setSuccess(false)

    try {
      const response = await fetch(configurationsService.newsLetterEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      })

      const data = await response.json()

      if (!response.ok || !data.success) {
        throw new Error(data.error || `API error: ${response.status}`)
      }

      setSuccess(true)

      return true
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred'
      console.error('Newsletter subscription error:', errorMessage)
      setError(errorMessage)
      setSuccess(false)
      return false
    } finally {
      setIsLoading(false)
    }
  }

  return {
    subscribe,
    isLoading,
    success,
    error
  }
}
